<template>
  <!-- CART DROPDOWN -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon
      icon="ShoppingCartIcon"
      class="cursor-pointer ml-2 mr-2 mt-1"
      :badge="cartItems.length ? cartItems.length : '' | persian_digits"
    />
    <vs-dropdown-menu class="cart-dropdown vx-navbar-dropdown dropdown-custom">
      <!-- IF CART HAVE ITEMS: HEADER -->
      <template v-if="cartItems.length">
        <div class="notification-header text-center p-5 bg-primary text-white">
          <h3 class="text-white">{{ cartItems.length | persian_digits }}</h3>
          <p class="opacity-75">{{ $t('invoices.invoice_to_pay') }}</p>
        </div>

        <!-- CART ITEMS -->
        <component
          :is="scrollbarTag"
          ref="mainSidebarPs"
          class="scroll-area--cart-items-dropdowm p-0 mb-10"
          :key="$vs.rtl"
        >
          <ul class="bordered-items">
            <li
              v-for="invoice in cartItems"
              :key="invoice.id"
              class="vx-row no-gutter cart-item cursor-pointer"
              @click="
                $router
                  .push({
                    name: invoice.requestId.startsWith('health') ? 'invoice-view' : 'reserve-invoice-view',
                    params: { id: invoice.id }
                  })
                  .catch(() => {})
              "
            >
              <!-- IMG COL -->
              <!--<div class="vx-col w-1/5 item-img-container bg-white flex items-center justify-center">
                <img :src="item.image" alt="item" class="cart-dropdown-item-img p-4" />
              </div>-->

              <!-- INFO COL -->
              <div class="vx-col pr-4 pl-2 py-4 w-3/4">
                <span class="font-medium block cart-item-title truncate">
                  {{ invoice.created_at | datetime }}
                </span>
                <div class="flex items-center justify-between text-sm">
                  {{ invoice.items[0].count | persian_digits }} {{ $t(`units.${invoice.items[0].unit}`) }}
                  {{ invoice.items[0].service_name }}
                  <template v-if="invoice.items.length > 1">{{
                    $t('invoices.items_more', { count: invoice.items.length - 1 }) | persian_digits
                  }}</template>
                </div>
              </div>
              <div class="vx-col w-1/4 pt-6">
                <span class="font-medium block cart-item-title truncate">
                  {{ invoice.totalPrice | toman }}
                </span>
              </div>
            </li>
          </ul>
        </component>
        <div
          class="checkout-footer fixed bottom-0 rounded-b-lg text-primary font-semibold w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
          @click="$router.push({ name: 'invoice-list', query: { state: 'unpaid' } }).catch(() => {})"
        >
          <span class="flex items-center justify-center">
            <feather-icon icon="ShoppingCartIcon" svgClasses="h-4 w-4" />
            <span class="ml-2">{{ $t('invoices.see_all') }}</span>
          </span>
        </div>
      </template>

      <!-- IF CART IS EMPTY -->
      <template v-else>
        <div class="notification-top text-center p-5 bg-primary text-white">
          <h3 class="text-white">{{ cartItems.length | persian_digits }}</h3>
          <p class="opacity-75">{{ $t('invoices.invoice_to_pay') }}</p>
        </div>
        <p class="p-4">{{ $t('invoices.cart_is_empty') }}</p>
      </template>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  computed: {
    cartItems() {
      return this.$store.state.invoice.unpaidInvoices
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  created() {
    this.$store.dispatch('invoice/fetchUnpaidInvoices', {
      skip: 0,
      limit: 100
    })
  }
}
</script>
